import Head from 'next/head';

import SignInForm from 'components/forms/sign-in-form';
import AuthLayout from 'components/layout/auth-layout';

function SignInPage() {
  return (
    <AuthLayout>
      <Head>
        <title>Sign-In</title>
      </Head>
      <SignInForm />
    </AuthLayout>
  );
}

export default SignInPage;
